import React, { useEffect, useState } from "react";
import Layout from "../../../components/Accounts/Layout";
import TransactionFeeContainer from "../../../components/Accounts/TransactionFeeContainer";
import Button from "../../../components/Button/Button";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { useQuery } from "@apollo/client";
import { getUserBankDetails } from "../../../graphql/queries/accounts";
import {
  getAccountConfiguration,
  GetAccountConfigurationResponse,
} from "../../../utils/getAccountConfig";
import { setFormValues } from "../../../store/formValues";
import { paymentDetailsInput } from "./data";
import { InputAndTransactionFeeWrapper } from "../FipayTransfer/PaymentDetails";
import { InputItem } from "../data";
import InputContainer from "../../../components/Accounts/InputContainer";

interface PaymentDetailsProps {
  handleNext: (step: number) => void;
  prevValues: InputItem[];
  transferType: string;
}

const PaymentDetailsWireTransfer: React.FC<PaymentDetailsProps> = ({
  handleNext,
  prevValues,
  transferType,
}) => {
  const dispatch = useDispatch();
  const id = useSelector((state: RootState) => state.user?.user?.id);
  const formValues = useSelector(
    (state: RootState) => state.formValues.wireTransfer
  );

  // const { data: userBankQueryData, refetch: refetchUserBank } = useQuery(
  //   getUserBankDetails,
  //   {
  //     variables: { getUserBankDetailsId: id },
  //   }
  // );

  // const financeDetails = userBankQueryData?.getUserBankDetails || "";

  // const amountValue = financeDetails?.userFinancialDetails?.available || 0;

  const { data: userBankQueryData, refetch: refetchUserBank } =
    useQuery(getUserBankDetails);

  const financeDetails = userBankQueryData?.getUserBankDetails || "";

  const amountValue = financeDetails?.userFinancialDetails?.available || 0;

  useEffect(() => {
    refetchUserBank();
  }, [id]);

  const [config, setConfig] =
    React.useState<GetAccountConfigurationResponse | null>(null);
  React.useEffect(() => {
    (async () => {
      const data = await getAccountConfiguration();
      setConfig(data);
    })();
  }, []);

  const transactionFee = config?.transactionFee?.toFipayUser || 0;
  return (
    <Layout>
      <Formik
        initialValues={{
          RecipientSwiftCode: formValues?.RecipientSwiftCode || "",
          RecipientIBAN: formValues?.RecipientIBAN || "",
          Amount: formValues?.Amount || "",
          Purpose: formValues?.Purpose || "",
        }}
        validationSchema={Yup.object({
          RecipientSwiftCode: Yup.string().required("Required"),
          RecipientIBAN: Yup.string().required("Required"),
          Purpose: Yup.string().required("Required"),
          Amount: Yup.number()
            .min(5, "Amount must be greater than or equal to $5")
            .max(
              amountValue,
              `Amount must be less than or equal to ${amountValue}`
            )
            .required("Required"),
        })}
        onSubmit={(values) => {
          try {
            if (+values.Amount > amountValue) {
              throw new Error("Amount cannot exceed available balance");
            }
            handleNext(3);
            const formData = {
              ...prevValues,
              ...values,
              TransactionFee: transactionFee,
            };
            dispatch(setFormValues({ [transferType]: formData }));
          } catch (error) {
            console.error("Error submitting form:", error);
          }
        }}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <>
              {paymentDetailsInput.map((input, index) => (
                <InputAndTransactionFeeWrapper key={index}>
                  <InputContainer
                    name={input.name}
                    label={input.label}
                    type={input.type}
                    placeholder={input.placeholder}
                    value={
                      formik.values[input.name as keyof typeof formik.values] ||
                      ""
                    }
                    onChange={(e) => {
                      formik.handleChange(e);
                    }}
                    width={"100%"}
                    error={
                      formik.touched[
                        input.name as keyof typeof formik.touched
                      ] &&
                      formik.errors[input.name as keyof typeof formik.errors]
                    }
                    hasPrefix={input.placeholder !== ""}
                  />

                  {input.hasTransactionFee && (
                    <TransactionFeeContainer
                      transactionFee={formik.values.Amount ? transactionFee : 0}
                      currency={"$"}
                      style={{ marginLeft: "auto" }}
                    />
                  )}
                </InputAndTransactionFeeWrapper>
              ))}
            </>
            <Button
              id={""}
              type="submit"
              padding={"10px 45%"}
              title={"Next"}
              border="10px"
              green
              disabled={!formik.isValid || !formik.dirty}
            />
          </form>
        )}
      </Formik>
    </Layout>
  );
};

export default PaymentDetailsWireTransfer;
